import React, { ReactNode } from 'react';
import styles from './requirementalertlist.module.scss';

interface Props {
  children: ReactNode;
}

const RequirementAlerts = (props: Props) => {
  return (
    <div className={styles.container}>
      {props.children}
    </div>
  )
}

export default RequirementAlerts;
